import React, { useContext } from 'react';
import './container.scss';
import { TeApiContext } from '@ecommerce/nest-ssr/common';

const Container: React.FC<{className?: string;}> = ({ className, children }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className={`container ${api.getDevice() === 'mobile' ? 'container--m' : ''} ${className || ''}`}>
            {children}
        </div>
    );
};

export default Container;
